<template>
    <div id="listnews">
        <div class="listnewsbox">

            <el-table :data="tableData" class="listnewsrightbox" 
            style=" font-size: 16px"
            :row-style="{height:'35px', lineHeight:'35px'}"
            :cell-style="{padding:'0px'}"
            >
                <el-table-column prop="id" label="ID" width="65">
                </el-table-column>

                <el-table-column prop="type" width="196">
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-s-grid" style="font-size:25px;"></i>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="title" width="210" show-overflow-tooltip>
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-postcard" style="font-size:25px;"></i>
                        </div>
                    </template>                    
                </el-table-column>

                <el-table-column prop="author">
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-user" style="font-size:25px;"></i>
                        </div>
                    </template>   
                </el-table-column>

                <el-table-column prop="time"  width="185">
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-time" style="font-size:25px;"></i>
                        </div>
                    </template>                      
                </el-table-column>      

                <el-table-column prop="locked">
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-lock" style="font-size:25px;"></i>
                        </div>
                    </template> 
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.locked"
                        inactive-color="#939695"
                        active-color="#ff4949"
                        :inactive-value="0"
                        :active-value="1"
                        :disabled="!isAdminFlag"
                        @change="changeSwitch(scope.row)"
                        > 
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column prop="address4">
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-delete" style="font-size:25px;"></i>
                        </div>
                    </template> 
                </el-table-column>

                <el-table-column prop="edit">
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-edit" style="font-size:25px;"></i>
                        </div>
                    </template> 
                    <template slot-scope="scope">
                        
                        <el-button type="primary" 
                        icon="el-icon-edit" 
                        circle size="small" 
                        color-primary="#939695" 
                        v-on:click="editnews(scope.row.id)"
                        ></el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <!-- 分页 -->
            <template> 
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage" 
                    :page-sizes="[20]" 
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="this.pages[0].total_news">
                    </el-pagination>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { request } from '@/api/http';
import { getNewsTypeName } from '@/constants/newsTypes';

export default {
    data () {
        return {
            tableData: [],
            currentPage: parseInt(this.$route.params.page),
            
            pages:[ 
                {
                    total_news: 0,
                }
            ],
            // 当前登录用户信息
            currentUser: sessionStorage.getItem('loginin') || '',
            isAdminFlag: sessionStorage.getItem('isAdmin') === '1',
        }
    },
    mounted(){
        this.getfirstnewspage();
    },

    methods: {
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);

            this.currentPage = val;
            
            let type = this.$route.params.type;
            
            this.$router.push({ name: 'listnews', params: { type: type, page: val }});
        },



        //locked的开关（仅管理员可用）
        changeSwitch (data) {
            request('/CalawaEnServlet/NewsServlet', {
                action: 'updateNews',
                id: data.id,
                locked: data.locked,
                username: this.currentUser,
                isAdmin: this.isAdminFlag ? 1 : 0,
            }).then(res => {
                if (res.data && res.data.result === false) {
                    this.$message.error('锁定操作需管理员授权');
                    this.getfirstnewspage();
                }
            }).catch(error=> {
                console.log(error);
            });
        },

        getfirstnewspage(){
            let type = this.$route.params.type;
            let page = this.$route.params.page;

            request('/CalawaEnServlet/NewsServlet', { action: 'getNewsList', type, page, username: this.currentUser, isAdmin: this.isAdminFlag ? 1 : 0 })
            .then(res=> {
                this.pages = [res.data];
                this.tableData = [];
                //将type从数字转为名称
                res.data.news_list.forEach(item => {
                    item.type = getNewsTypeName(item.type);
                    this.tableData.push(item);
                });
            })
            .catch(error=> {
                console.log(error);
            });
        },

        editnews(id){
            this.$router.push({ name: 'uploadnews', params: { id }});
        },
    },
}
</script>

<style lang="scss" scoped>
@mixin oneline(){
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.el-table th>.cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#listnews{
    width: 100%;
    .listnewsbox{
        width: 1083px;
        margin: 0 auto;

        .el-row{
            .el-col:nth-child(1){
                min-height: 800px;

                background-color: #5262B3FF !important;

                :nth-child(1){
                    height:40px;
                    line-height:40px;

                    text-align: left;

                    // padding-left: 5px !important;
                }
                .el-submenu{
                    .el-menu-item{
                        height:35px;
                        line-height:35px;

                        text-align: left;

                        @include oneline();

                        // padding-left: 45px !important;
                        padding-right: 0;
                    }
                }

            }

            .el-col:nth-child(2){
                padding: 20px 0 0 10px;
                .el-table.listnewsrightbox {
                    width: 100%;
                }

            }
        }
        
    }
}
</style>